import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HlmToaster } from '../helm/sonner/src/lib/hlm-toaster';

@Component({
  selector: 'app-ui-toast',
  template: '<hlm-toaster position="bottom-center" richColors closeButton />',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HlmToaster],
})
export class UiToastComponent {}
